export default __webpack_public_path__ + "static/Sklad-6f4d011f994fc8928535218e3243a0a0.jpg";